import React from "react";
import { Nav, NavItem } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NavItems = (props: any) => {
  const { id, immigration_id, application_id, isDocumentsTab } = props;
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Nav tabs>
        <NavItem>
          <Link
            style={{ cursor: "pointer" }}
            to={`/immigration/update-application/${id}/${immigration_id}/${application_id}`}
            className={!isDocumentsTab ? "active nav-link" : "nav-link"}
          >
            {t("Application")}
          </Link>
        </NavItem>

        {application_id && (
          <NavItem>
            <Link
              style={{ cursor: "pointer" }}
              to={`/immigration/update-documents/${id}/${immigration_id}/${application_id}`}
              className={isDocumentsTab ? "active nav-link" : "nav-link"}
            >
              {t("Documents")}
            </Link>
          </NavItem>
        )}
      </Nav>
    </React.Fragment>
  );
};

export default NavItems;
